import React from "react";
import { Paper, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

interface ConfirmationCheckboxProps {
  isConfirmed: boolean;
  isDisabled: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
}

export const ConfirmationCheckbox: React.FC<ConfirmationCheckboxProps> = ({
  isConfirmed,
  isDisabled,
  onChange,
  label = "I confirm that all information on this page is correct and accurate"
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 3,
        p: 2.5,
        borderRadius: 2,
        bgcolor: isConfirmed
          ? alpha(theme.palette.success.main, 0.04)
          : alpha(theme.palette.warning.main, 0.04),
        border: `1px solid ${
          isConfirmed
            ? alpha(theme.palette.success.main, 0.2)
            : alpha(theme.palette.warning.main, 0.2)
        }`,
        transition: "all 0.2s ease-in-out",
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={isConfirmed}
            disabled={isDisabled}
            onChange={(e) => onChange(e.target.checked)}
            sx={{
              color: isConfirmed ? "success.main" : "warning.main",
              "&.Mui-checked": { color: "success.main" },
            }}
          />
        }
        label={
          <Typography variant="body2" fontWeight={500}>
            {label}
          </Typography>
        }
      />
    </Paper>
  );
};
